export default __webpack_public_path__ + "static/media/guava.f4b89bcb.png";